/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Preview_KubaInputs */

const en_platform_preview_kuba = /** @type {(inputs: Platform_Preview_KubaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuba Mazur · Strength`)
};

const pl_platform_preview_kuba = /** @type {(inputs: Platform_Preview_KubaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuba Mazur · Trening siłowy`)
};

/**
* | output |
* | --- |
* | "Kuba Mazur · Strength" |
*
* @param {Platform_Preview_KubaInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_preview_kuba = /** @type {((inputs?: Platform_Preview_KubaInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Preview_KubaInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_preview_kuba(inputs)
	return en_platform_preview_kuba(inputs)
});